import type { DocumentPageListItem } from '@avisoma//shared';
import YAML from 'yaml';

export function DocumentPageMetadataAdvancedColumn({ page }: { page: DocumentPageListItem }) {
  return (
    <div className="bg-gray-50 dark:bg-zinc-800 border dark:border-zinc-700 p-3 aspect-3/4 overflow-y-auto shadow-[0_0_10px_rgba(0,0,0,0.1)]">
      <div className="text-[8px] text-gray-900 dark:text-zinc-100 font-mono">
        <ul>
          {Object.entries(page.processing?.metadata?.result ?? {}).map(([key, value]) => (
            <li key={key} className="flex flex-col mb-2">
              <span className="font-bold text-zinc-700 dark:text-zinc-300">{key}</span>
              <span className="text-zinc-600 dark:text-zinc-400 text-[8px] font-mono whitespace-pre-wrap">
                {typeof value === 'boolean'
                  ? value.toString()
                  : typeof value === 'object'
                    ? YAML.stringify(value)
                    : value}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
